import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussions</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              SDSS is designed to focus on the conservation of protected areas
              in Karnataka (KPASDSS), which allows data management (updating and
              manipulation), data visualisation with options of OGC based web
              protocols - WMS, WFS. The servers request-response fetches vector
              and raster data through OGC web mapping standards including GML,
              and SLD (Styled Layer Descriptor is an XML-based markup language).
              KPASDSS main window is shown in Fig. 21.4 with default Open Layers
              backdrop. The user has options to select layers based on themes.
              Data for creating these layers were compiled through ecological
              field investigations and compilation from disparate sources
              (published literatures). The user will be able to visualize the
              spatial information and also analyse multi layers simultaneously.
              This consists of the options to change backdrop with Bhuvan
              (ISRO&rsquo;s Geo-Portal available in the public domain for
              providing visualisation services), Google maps, Bing maps, etc.
              Fig. 21.5 shows the PAs with land use data available at Bhuvan. In
              addition, the end users have access to numerous HTML pages such as
              photographs, help, glossary, existing publications and management
              plans of each PA, external links, references list and brief
              textual information for viewing and querying spatial layers.
            </p>
            <p>
              SDSS manages the information of the PAs in Karnataka with options
              for analyses and visualisation. Fig.21.6 shows land use details of
              various PAs selected and land uses of the different time periods
              may also be viewed. The report option provides land use details
              across each category of selected PAs. For example, Fig. 21.7
              depicts forest cover from 1973 to 2016 and likely land use of 2026
              in Someshwara WLS (SWLS) and Bhadra WLS (BWLS). The land use
              change analysis using temporal remote sensing data reveals that
              the evergreen forest cover has declined from 38.75 (1973) to
              31.43% (2016) in the SWLS. Similarly, deciduous forest cover has
              declined from 50.09 to 37.43 % in BWLS during the past four
              decades (1973-2016) with an increase of plantations, agriculture
              activities, which are threatening the ecological integrity of the
              PA. CA Markov modelling highlights the likely shift from
              agriculture to horticulture across PAs. SWLS would witness further
              erosion of evergreen cover from 31.43 to 28.84% (2016-2026),
              increasing the area under horticulture from 21.46 to 28.08%
              (2026). BWLS also will witness an increase in monoculture
              plantations followed by horticulture. Deciduous forest would
              disappear from 37.43 to 34.71% (2016-2026) with an increase of
              horticulture from 15 to 19% in BWLS. The changes will impact wild
              fauna and the region currently sustains tiger population. The
              earlier coffee estates in buffer region with native vegetation
              supporting diverse herbivorous populations are being transformed
              into commercial rubber plantations, causing a serious impact on
              wildlife. The conversion from tea estate to rubber plantations is
              another major threat to the fragile ecosystem in recent times.
              Query-based visualisation will help decision-makers to frame
              appropriate policies to arrest further degradations of PAs.
            </p>
            <p>&nbsp;</p>
            <table>
              <tbody>
                <tr>
                  <td>
                    {" "}
                    <img src="images/vds4.png" alt="" />{" "}
                  </td>
                  <td>
                    {" "}
                    <img
                      height={460}
                      width={600}
                      src="images/vds5.png"
                      alt=""
                    />{" "}
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>
                      <strong>Fig. 21.4</strong> KPASDSS and layers available
                    </p>
                  </td>
                  <td>
                    <p>
                      <strong>Fig. 21.5</strong> Visualisation of PAs on Bhuvan
                      WMS layer
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <table>
              <tbody>
                <tr>
                  <td>
                    {" "}
                    <img
                      height={460}
                      width={500}
                      src="images/vds6.png"
                      alt=""
                    />{" "}
                  </td>
                  <td>
                    {" "}
                    <img src="images/vds7.png" alt="" />{" "}
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>
                      <strong>Fig. 21.6</strong> Visualisation of various PAs
                      with land uses
                    </p>
                  </td>
                  <td>
                    <p>
                      <strong>Fig. 21.7</strong> Land use dynamics with likely
                      LU changes by 2026 in SWLS and BWLS.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>21.4 DISCUSSION</strong>
            </p>
            <p>
              Geovisualisation offers a visual interface with computational
              analysis capabilities and modelling based on human-computer
              interaction, geographic information science, operations research,
              data mining and machine learning, decision science, cognitive
              science, and other disciplines in solving complex decision
              problems (Andrienko et al., 2007). SDSS provides an opportunity to
              integrate multi-criterion evaluation (MCE) approaches of decision
              making with a set of alternatives, which can be evaluated by the
              pros and cons of each option&rsquo;s properties for effective
              resource assessment and planning (Ruda, 2016;
              Gebetsroither-Geringer et al., 2018; Beard et al., 2018). SDSS has
              emerged as a powerful and flexible tool developed for different
              environmental applications and supports in framing policy measures
              for the global biodiversity hotspots (Karnatak and Roy, 2019).
            </p>
            <p>
              PAs have been playing vital role in ecosystem conservation as a
              refuge for sensitive wild flora and fauna, while maintaining
              ecosystem balance. Long-term conservation and management of PAs
              depend on how well they are protected from the threats such as
              encroachment, fire, hunting/poaching, and other unsustainable
              resource harvesting. The human-induced land use land cover (LULC)
              changes adversely impact these regions and result in loss of
              productivity and biodiversity. LULC changes in the forested areas
              can abruptly influence the underlying ecological processes, carbon
              sequestration potential, increase emissions, induce climate change
              and affect a broad range of ecosystem service supply (Ramachandra
              and Bharath, 2019). Understanding landscape dynamics and
              visualisation of likely LULC transitions would help take
              location-specific ecosystem approaches of conservation measures
              and manage natural resources through stakeholder&rsquo;s
              participation (Ramachandra et al. 2016) and maintain ecological
              integrity. Merging of scientific knowledge through spatial
              technologies provides an important step towards using science to
              inform stakeholders and assist decision-makers in the effective
              policy decisions.
            </p>
            <p>
              <strong>&nbsp;</strong>
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
